<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="save">确定</el-button>
    </div>
    <div class="main">
        <el-form :model="list" required label-position="right" class="mainfrom">
          <el-form-item label="状态">
            <div>
                <el-radio v-for="(item, index) in psustatusList"
                  :key="index" v-model="list.psustatus" @change="changestatus"
                  :label="item.value">{{item.label}}</el-radio>
            </div>
          </el-form-item>
          <el-form-item label="驳回原因" required class="content" v-if="+isEdit === 3">
              <el-input type="textarea" :autosize="{ minRows: 2}"
                    v-model.trim="list.psubmcheckdesc" :maxlength="255" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="拒绝原因" class="content" v-if="+isEdit === 4">
              <el-input type="textarea" :autosize="{ minRows: 2}"
                    v-model.trim="list.psubmcheckdesc" :maxlength="255" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="项目编号" class="linkstyle">
              <span  @click="goProjectInfo">{{list.projectcode}}</span>
          </el-form-item>
          <el-form-item label="项目名称" class="linkstyle">
              <span  @click="goProjectInfo">{{list.projectname}}</span>
          </el-form-item>
          <el-form-item label="采购单位" class="from-value">
              {{list.comfullname}}
          </el-form-item>
        </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import uploadBtn from '../common/uploadBtn'
  import common from '@/mixin/common'
  export default {
    name: "pInviteInfo",
    mixins: [common,uploadBtn,uploadPicOne],
    data () {
      return {
        from: this.$route.params.form,
        list:{},
        isEdit:0,
        psustatusList:[],
        btnLoading:false
      }
    },
    created () {
    },
    activated () {
      this.init()
      this.getpsubyid()
      this.getPsustatusList()
    },
    watch: {},
    filters: {},
    components: {},
    computed: {
    },
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async init () {
        this.isEdit = 0
      },
      async getpsubyid(){
        let res = await request({
          url: '/xmgl/project/getpsubyid',
          method: "get",
          params: this.from
        })
        this.list = res[0]
      },
      async getPsustatusList () {
        this.psustatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'psustatus'}
        })
        this.psustatusList.splice(0, 1)
        this.psustatusList.splice(1, 1)
      },
      changestatus(e){
        this.list.psubmcheckdesc = ''
        this.isEdit = e
      },
      async save(){
        this.list.psuuserid = this.$store.getters.loginUser.userid

        await request({
          url: '/xmgl/project/confirminvite',
          method: "post",
          data: this.list
        })
      },
      async goProjectInfo(){
        this.$router.push({name: 'projectForm', params: {form: this.from, type: 3}})
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "../../styles/filelist";

  .main {
    .amt {
      display: flex;
      flex-direction: column;
    }
    .link {
      padding-left: 10px;
      color: #2f74ff;
      cursor: Pointer;
    }
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 200px;
    }
    .file {
      display: flex;
      flex-direction: column;
      width: 70%;
    }
  }
  .projectinfo{
    display: block;
    cursor: pointer;
    padding-left: 20px;
    color: blue !important;
  }
</style>
